// import React, { useCallback, useEffect, useMemo, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   Check, X, RefreshCw, AlertCircle, Loader2, Eye,
//   ChevronDown, Clock, CheckCircle, XCircle, ChevronLeft, ChevronRight,
//   User, Users, Search
// } from 'lucide-react';

// import {
//   GetPendingLeave,
//   GetApprovedLeave,
//   GetRejectedLeave,
//   GetCanceledLeave,
//   ApproveLeave as ApproveLeaveAction,
//   RejectLeave as RejectLeaveAction,
// } from '../../action/Leave';

// import LeaveService from '../../services/LeaveService';

// // ─── Status Configuration ──────────────────────────────────────────────────
// const STATUS_META = {
//   PENDING: { bg: 'bg-amber-50 text-amber-700', border: 'border-amber-200', icon: Clock, label: 'Pending' },
//   APPROVED: { bg: 'bg-emerald-50 text-emerald-700', border: 'border-emerald-200', icon: CheckCircle, label: 'Approved' },
//   REJECTED: { bg: 'bg-red-50 text-red-700', border: 'border-red-200', icon: XCircle, label: 'Rejected' },
// };

// const StatusIcon = ({ status }) => {
//   const up = (status || '').toUpperCase();
//   const Icon = STATUS_META[up]?.icon || Clock;
//   return <Icon size={12} />;
// };

// // ─── Safe field getter ────────────────────────────────────────────────────
// const g = (leave, key) => {
//   const v = leave?.[key];
//   return (!v || v === 'null') ? '' : String(v).trim();
// };

// const getFormId = (l) => g(l, 'HLF_FORM_ID');
// const getFormNo = (l) => g(l, 'HLF_FORM_NO');
// const getServiceNo = (l) => g(l, 'HLF_EMP_SERVICE_NO');
// const getTypeId = (l) => g(l, 'HLF_LEAVE_TYPE_ID');
// const getFromDate = (l) => g(l, 'HLF_FROM_DATE');
// const getToDate = (l) => g(l, 'HLF_TO_DATE');
// const getTotalDays = (l) => g(l, 'HLF_TOTAL_DAYS');
// const getReason = (l) => g(l, 'HLF_REASON');
// const getStatus = (l) => g(l, 'HLF_STATUS');
// const getContactNo = (l) => g(l, 'HLF_CONTACT_NO') || g(l, 'p_hlf_contact_no') || '';
// const getAttachmentPath = (l) => g(l, 'HLF_ATTACHMENT_PATH') || '';
// const isPendingLeave = (l) => getStatus(l).toUpperCase() === 'PENDING';

// const fmtDate = (v) => {
//   if (!v) return '—';
//   try { return new Date(v).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }); }
//   catch { return String(v); }
// };

// // ─── Filter Options ──────────────────────────────────────────────────────
// const FILTER_OPTIONS = [
//   { value: 'ALL', label: 'All Requests' },
//   { value: 'PENDING', label: 'Pending' },
//   { value: 'APPROVED', label: 'Approved' },
//   { value: 'REJECTED', label: 'Rejected' },
// ];

// const ROWS_PER_PAGE = 8;

// // ─── Employee Selector Component ──────────────────────────────────────────
// function EmployeeSelector({ employees, selectedEmployee, onSelect, loading }) {
//   const [searchTerm, setSearchTerm] = useState('');
//   const [isOpen, setIsOpen] = useState(false);
//   const dropdownRef = React.useRef(null);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsOpen(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   const filteredEmployees = useMemo(() => {
//     if (!employees || !Array.isArray(employees)) return [];
//     if (!searchTerm) return employees;
//     const term = searchTerm.toLowerCase();
//     return employees.filter(emp => {
//       const name = (emp.p_report_name || emp.HED_REPORT_NAME || emp.reportName || '').toLowerCase();
//       const serviceNo = (emp.p_ced_service_no || emp.HED_SERVICE_NO || emp.serviceNo || '').toLowerCase();
//       return name.includes(term) || serviceNo.includes(term);
//     });
//   }, [employees, searchTerm]);

//   const getEmployeeName = (emp) => {
//     return emp.p_report_name ||
//       emp.HED_REPORT_NAME ||
//       emp.reportName ||
//       `${emp.p_first_name || ''} ${emp.p_last_name || ''}`.trim() ||
//       'Unnamed Employee';
//   };

//   const getEmployeeServiceNo = (emp) => {
//     return emp.p_ced_service_no ||
//       emp.HED_SERVICE_NO ||
//       emp.HED_CED_SERVICE_NO ||
//       emp.serviceNo ||
//       '';
//   };

//   const selectedEmployeeData = employees?.find(
//     emp => getEmployeeServiceNo(emp) === selectedEmployee
//   );

//   return (
//     <div className="relative w-64" ref={dropdownRef}>
//       <button
//         onClick={() => setIsOpen(!isOpen)}
//         className="flex w-full items-center justify-between rounded-lg border border-gray-200 bg-white px-3.5 py-2 text-sm text-gray-700 hover:border-primary-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-colors"
//         disabled={loading}
//       >
//         <span className="flex items-center gap-2 truncate">
//           <User size={15} className="text-gray-400 shrink-0" />
//           {selectedEmployeeData ? (
//             <span className="truncate">
//               <span className="font-medium">{getEmployeeName(selectedEmployeeData)}</span>
//             </span>
//           ) : (
//             <span className="text-gray-500">All Employees</span>
//           )}
//         </span>
//         <ChevronDown size={15} className={`text-gray-400 transition-transform shrink-0 ${isOpen ? 'rotate-180' : ''}`} />
//       </button>

//       {isOpen && (
//         <div className="absolute left-0 right-0 z-50 mt-1 max-h-72 overflow-y-auto rounded-lg border border-gray-200 bg-white shadow-lg">
//           <div className="sticky top-0 bg-white p-2 border-b border-gray-100">
//             <div className="relative">
//               <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
//               <input
//                 type="text"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 placeholder="Search by name or service no..."
//                 className="w-full rounded-lg border border-gray-200 bg-gray-50 px-3 py-1.5 pl-9 text-sm outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
//               />
//             </div>
//           </div>

//           <div className="py-1">
//             <button
//               onClick={() => {
//                 onSelect('ALL');
//                 setIsOpen(false);
//                 setSearchTerm('');
//               }}
//               className={`w-full px-4 py-2 text-left text-sm hover:bg-primary-50 transition-colors ${selectedEmployee === 'ALL' ? 'bg-primary-50 text-primary-700' : 'text-gray-700'
//                 }`}
//             >
//               <span className="flex items-center gap-2">
//                 <Users size={14} />
//                 All Employees
//               </span>
//             </button>

//             {filteredEmployees.length === 0 ? (
//               <div className="px-4 py-3 text-sm text-gray-400">No employees found</div>
//             ) : (
//               filteredEmployees.map(emp => {
//                 const serviceNo = getEmployeeServiceNo(emp);
//                 const name = getEmployeeName(emp);
//                 return (
//                   <button
//                     key={serviceNo || Math.random()}
//                     onClick={() => {
//                       onSelect(serviceNo);
//                       setIsOpen(false);
//                       setSearchTerm('');
//                     }}
//                     className={`w-full px-4 py-2 text-left text-sm hover:bg-primary-50 transition-colors ${selectedEmployee === serviceNo ? 'bg-primary-50 text-primary-700' : 'text-gray-700'
//                       }`}
//                   >
//                     <div className="flex items-center justify-between">
//                       <span>{name}</span>
//                       <span className="text-xs text-gray-400">{serviceNo}</span>
//                     </div>
//                   </button>
//                 );
//               })
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// // ─── Status Badge Component ─────────────────────────────────────────────
// function StatusBadge({ status }) {
//   const up = (status || '').toUpperCase();
//   const meta = STATUS_META[up];

//   if (!meta) {
//     return (
//       <span className="inline-block rounded-full px-3 py-1 text-xs font-medium bg-gray-100 text-gray-500">
//         {status || '—'}
//       </span>
//     );
//   }

//   return (
//     <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium border ${meta.bg} ${meta.border}`}>
//       <StatusIcon status={status} />
//       {meta.label}
//     </span>
//   );
// }

// // ─── Detail Field Component ─────────────────────────────────────────────
// function DetailField({ label, children }) {
//   return (
//     <div className="flex flex-col gap-1">
//       <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">{label}</span>
//       <div className="text-sm text-gray-800">{children || '—'}</div>
//     </div>
//   );
// }

// // ─── Pagination Component ──────────────────────────────────────────────────
// function Pagination({ currentPage, totalPages, onPageChange, itemsCount, totalItems }) {
//   if (totalPages <= 1) return null;

//   const getPageNumbers = () => {
//     const pages = [];
//     const maxVisible = 5;
//     let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
//     let end = Math.min(totalPages, start + maxVisible - 1);

//     if (end - start < maxVisible - 1) {
//       start = Math.max(1, end - maxVisible + 1);
//     }

//     for (let i = start; i <= end; i++) {
//       pages.push(i);
//     }
//     return pages;
//   };

//   return (
//     <div className="flex items-center justify-between px-5 py-3 border-t border-gray-200">
//       <div className="text-sm text-gray-500">
//         Showing <span className="font-medium">{itemsCount}</span> of{' '}
//         <span className="font-medium">{totalItems}</span> entries
//       </div>
//       <div className="flex items-center gap-1">
//         <button
//           onClick={() => onPageChange(currentPage - 1)}
//           disabled={currentPage === 1}
//           className="p-2 rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
//         >
//           <ChevronLeft size={16} />
//         </button>

//         {getPageNumbers().map((page) => (
//           <button
//             key={page}
//             onClick={() => onPageChange(page)}
//             className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${currentPage === page
//               ? 'bg-primary-600 text-white'
//               : 'text-gray-600 hover:bg-gray-50'
//               }`}
//           >
//             {page}
//           </button>
//         ))}

//         <button
//           onClick={() => onPageChange(currentPage + 1)}
//           disabled={currentPage === totalPages}
//           className="p-2 rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
//         >
//           <ChevronRight size={16} />
//         </button>
//       </div>
//     </div>
//   );
// }

// // ─── Stat Card Component ──────────────────────────────────────────────────
// function StatCard({ label, value, color }) {
//   return (
//     <div className={`rounded-xl border border-gray-200 bg-white px-4 py-2.5 shadow-sm ${color}`}>
//       <p className="text-xl font-bold">{value}</p>
//       <p className="text-[10px] font-medium uppercase tracking-wide">{label}</p>
//     </div>
//   );
// }

// // ─── Main Component ─────────────────────────────────────────────────────
// export default function LeaveApproval() {
//   const dispatch = useDispatch();
//   const { employees } = useSelector(s => s.employees || {});

//   // ── Get current user ID ────────────────────────────────────────────────
//   const currentUserId = useSelector(s => {
//     const fromAuth = s.auth?.user?.userId ||
//       s.auth?.user?.UserId ||
//       s.auth?.userId ||
//       s.auth?.UserId ||
//       s.auth?.user?.id ||
//       '';

//     if (fromAuth) return fromAuth;

//     try {
//       const storedUser = localStorage.getItem('user');
//       if (storedUser) {
//         const user = JSON.parse(storedUser);
//         const id = user?.id || user?.userId || user?.UserId || user?.serviceNo || '';
//         if (id) return id;
//       }
//     } catch (e) { }

//     return localStorage.getItem('userId') ||
//       localStorage.getItem('UserId') ||
//       localStorage.getItem('serviceNo') ||
//       'SYSTEMSEMS';
//   });

//   const [leaves, setLeaves] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [filter, setFilter] = useState('ALL');
//   const [selectedEmployee, setSelectedEmployee] = useState('ALL');
//   const [selectedRequest, setSelectedRequest] = useState(null);
//   const [remarks, setRemarks] = useState('');
//   const [deciding, setDeciding] = useState(false);
//   const [leaveTypeMap, setLeaveTypeMap] = useState({});
//   const [modalOpen, setModalOpen] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);

//   useEffect(() => {
//     let cancelled = false;
//     LeaveService.GetLeaveTypeList()
//       .then(res => {
//         const rows = res?.data?.ResultSet || res?.ResultSet || [];
//         const map = {};
//         rows.forEach(r => {
//           const id = r.HLT_TYPE_ID ?? r.TYPE_ID ?? r.TypeId;
//           const name = r.HLT_NAME ?? r.TYPE_NAME ?? r.TypeName;
//           if (id != null) map[String(id)] = name;
//         });
//         if (!cancelled) setLeaveTypeMap(map);
//       })
//       .catch(() => { });
//     return () => { cancelled = true; };
//   }, []);

//   // ── Employee map ────────────────────────────────────────────────────────
//   const employeeMap = useMemo(() => {
//     const map = {};

//     if (!employees || !Array.isArray(employees) || employees.length === 0) {
//       return map;
//     }

//     employees.forEach(e => {
//       const sno = e.p_ced_service_no ||
//         e.HED_SERVICE_NO ||
//         e.HED_CED_SERVICE_NO ||
//         e.serviceNo ||
//         e.HED_EMPLOYEE_ID ||
//         e.employeeId ||
//         '';

//       if (!sno) return;

//       const name = e.p_report_name ||
//         e.HED_REPORT_NAME ||
//         e.reportName ||
//         `${e.p_first_name || e.HED_FIRST_NAME || e.firstName || ''} ${e.p_last_name || e.HED_LAST_NAME || e.lastName || ''}`.trim() ||
//         e.name ||
//         '';

//       if (name) {
//         map[String(sno)] = name;
//       } else {
//         map[String(sno)] = String(sno);
//       }
//     });

//     return map;
//   }, [employees]);

//   // ── Fetch function ──────────────────────────────────────────────────
//   const fetchAllRequests = useCallback(async () => {
//     setLoading(true);
//     setError('');
//     try {
//       const [pendingResult, approvedResult, rejectedResult, cancelledResult] = await Promise.all([
//         dispatch(GetPendingLeave()),
//         dispatch(GetApprovedLeave()),
//         dispatch(GetRejectedLeave()),
//         dispatch(GetCanceledLeave()),
//       ]);

//       const pending = Array.isArray(pendingResult) ? pendingResult : (pendingResult?.payload || pendingResult?.data || []);
//       const approved = Array.isArray(approvedResult) ? approvedResult : (approvedResult?.payload || approvedResult?.data || []);
//       const rejected = Array.isArray(rejectedResult) ? rejectedResult : (rejectedResult?.payload || rejectedResult?.data || []);

//       const allLeaves = [
//         ...(Array.isArray(pending) ? pending : []),
//         ...(Array.isArray(approved) ? approved : []),
//         ...(Array.isArray(rejected) ? rejected : []),
//       ];

//       setLeaves(allLeaves);
//       setCurrentPage(1);
//     } catch (e) {
//       console.error('[LeaveApproval] Error fetching leaves:', e);
//       setError(typeof e === 'string' ? e : (e?.message || 'Failed to load leave requests'));
//       setLeaves([]);
//     } finally {
//       setLoading(false);
//     }
//   }, [dispatch]);

//   useEffect(() => { fetchAllRequests(); }, [fetchAllRequests]);

//   // ── Filtered requests (by status and employee) ──────────────────────────
//   const filteredRequests = useMemo(() => {
//     let result = leaves;

//     if (filter !== 'ALL') {
//       result = result.filter(r => getStatus(r).toUpperCase() === filter);
//     }

//     if (selectedEmployee !== 'ALL') {
//       result = result.filter(r => getServiceNo(r) === selectedEmployee);
//     }

//     return result;
//   }, [leaves, filter, selectedEmployee]);

//   // ── Paginated requests ──────────────────────────────────────────────────
//   const paginatedRequests = useMemo(() => {
//     const start = (currentPage - 1) * ROWS_PER_PAGE;
//     const end = start + ROWS_PER_PAGE;
//     return filteredRequests.slice(start, end);
//   }, [filteredRequests, currentPage]);

//   // ── Stats ──────────────────────────────────────────────────────────────
//   const stats = useMemo(() => ({
//     total: leaves.length,
//     pending: leaves.filter(r => getStatus(r).toUpperCase() === 'PENDING').length,
//     approved: leaves.filter(r => getStatus(r).toUpperCase() === 'APPROVED').length,
//     rejected: leaves.filter(r => getStatus(r).toUpperCase() === 'REJECTED').length,
//   }), [leaves]);

//   // ── Reset pagination when filter or employee changes ──────────────
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [filter, selectedEmployee]);

//   // ── Modal handlers ─────────────────────────────────────────────────────
//   const openModal = (request) => {
//     setSelectedRequest(request);
//     setRemarks('');
//     setError('');
//     setModalOpen(true);
//   };

//   const closeModal = () => {
//     setModalOpen(false);
//     setSelectedRequest(null);
//     setRemarks('');
//     setError('');
//   };

//   // ── Approve/Reject decision ─────────────────────────────────────
//   async function decide(status) {
//     if (!selectedRequest || deciding) return;

//     if (!currentUserId || currentUserId.trim() === '') {
//       setError('User ID is missing. Please log in again.');
//       return;
//     }

//     const currentStatus = getStatus(selectedRequest).toUpperCase();
//     if (currentStatus !== 'PENDING') {
//       setError('This request has already been processed.');
//       return;
//     }

//     setDeciding(true);
//     setError('');
//     try {
//       const formId = getFormId(selectedRequest);
//       const formNo = getFormNo(selectedRequest);

//       if (status === 'APPROVED') {
//         await dispatch(ApproveLeaveAction(formId, formNo, currentUserId, remarks));
//       } else {
//         await dispatch(RejectLeaveAction(formId, formNo, currentUserId, remarks));
//       }

//       await fetchAllRequests();
//       closeModal();
//     } catch (e) {
//       console.error('[LeaveApproval] Decision error:', e);
//       setError(typeof e === 'string' ? e : (e?.message || 'Failed to submit decision'));
//     } finally {
//       setDeciding(false);
//     }
//   }

//   // ─── Convert base64 data URL to Blob URL ──────────────────────────
//   const openAttachment = (dataUrl) => {
//     try {
//       const [header, base64Data] = dataUrl.split(',');
//       const mimeMatch = header.match(/data:(.*?);base64/);
//       const mimeType = mimeMatch ? mimeMatch[1] : 'application/octet-stream';

//       const byteString = atob(base64Data);
//       const byteArray = new Uint8Array(byteString.length);
//       for (let i = 0; i < byteString.length; i++) {
//         byteArray[i] = byteString.charCodeAt(i);
//       }

//       const blob = new Blob([byteArray], { type: mimeType });
//       const blobUrl = URL.createObjectURL(blob);

//       window.open(blobUrl, '_blank', 'noopener,noreferrer');

//       setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
//     } catch (err) {
//       console.error('[LeaveApproval] Failed to open attachment:', err);
//     }
//   };

//   // ── Handle employee selection ──────────────────────────────────────────
//   const handleEmployeeSelect = (employeeId) => {
//     setSelectedEmployee(employeeId);
//   };

//   return (
//     <div className="h-full flex flex-col">
//       {/* ── Header with Employee Search, Filter and Refresh ─────────── */}
//       <div className="flex flex-wrap items-center gap-3 px-4 pt-2 pb-1 flex-shrink-0">
//         {/* Employee Selector - Left */}
//         <div className="flex items-center gap-2">
//           <span className="text-sm text-gray-500 whitespace-nowrap">Employee:</span>
//           <EmployeeSelector
//             employees={employees}
//             selectedEmployee={selectedEmployee}
//             onSelect={handleEmployeeSelect}
//             loading={loading}
//           />
//         </div>

//         {/* Request Type Filter - Middle */}
//         <div className="relative">
//           <select
//             value={filter}
//             onChange={(e) => setFilter(e.target.value)}
//             className="appearance-none rounded-lg border border-gray-200 bg-white px-4 py-2 pr-9 text-sm text-gray-700 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 min-w-[160px]"
//           >
//             {FILTER_OPTIONS.map((opt) => (
//               <option key={opt.value} value={opt.value}>
//                 {opt.label}
//               </option>
//             ))}
//           </select>
//           <ChevronDown size={15} className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" />
//         </div>

//         {/* Refresh Button - Right */}
//         <button
//           onClick={fetchAllRequests}
//           disabled={loading}
//           className="flex shrink-0 items-center gap-2 rounded-lg border border-gray-200 bg-white px-3.5 py-2 text-sm font-medium text-gray-700 hover:bg-surface-50 transition-colors disabled:opacity-50"
//         >
//           <RefreshCw size={15} className={loading ? 'animate-spin' : ''} />
//           Refresh
//         </button>
//       </div>

//       {/* ── Stats Cards ──────────────────────────────────────────── */}
//       <div className="grid grid-cols-2 md:grid-cols-4 gap-3 px-4 py-3 flex-shrink-0">
//         <StatCard label="Total" value={stats.total} color="bg-gray-100 text-gray-700" />
//         <StatCard label="Pending" value={stats.pending} color="bg-amber-50 text-amber-700" />
//         <StatCard label="Approved" value={stats.approved} color="bg-emerald-50 text-emerald-700" />
//         <StatCard label="Rejected" value={stats.rejected} color="bg-red-50 text-red-700" />
//       </div>

//       {/* ── Error Display ────────────────────────────────────────── */}
//       {error && (
//         <div className="mx-4 mb-1 rounded-lg bg-red-50 p-2 text-sm text-red-700 border border-red-200 flex-shrink-0">
//           {error}
//         </div>
//       )}

//       {/* ── Table ─────────────────────────────────────────────────── */}
//       <div className="flex-1 min-h-0 mx-4 mb-4 rounded-xl border border-gray-200 bg-white shadow-sm overflow-hidden flex flex-col">
//         {loading ? (
//           <div className="flex items-center justify-center py-16 gap-3 text-gray-400 flex-1">
//             <Loader2 size={20} className="animate-spin text-primary-500" />
//             <span className="text-sm">Loading leave requests...</span>
//           </div>
//         ) : (
//           <>
//             <div className="flex-1 overflow-auto">
//               <table className="w-full min-w-[900px] border-collapse text-sm">
//                 <thead className="sticky top-0 z-10">
//                   <tr className="bg-gray-50">
//                     {['Form #', 'Employee', 'Leave Type', 'From', 'To', 'Days', 'Status', 'Actions'].map((h) => (
//                       <th
//                         key={h}
//                         className="whitespace-nowrap px-5 py-2.5 text-left text-xs font-semibold uppercase tracking-wide text-gray-500"
//                       >
//                         {h}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {paginatedRequests.length === 0 && (
//                     <tr>
//                       <td colSpan={8} className="px-5 py-10 text-center text-sm text-gray-400">
//                         {selectedEmployee !== 'ALL'
//                           ? `No ${filter !== 'ALL' ? filter.toLowerCase() : ''} leave requests found for this employee.`
//                           : filter === 'ALL'
//                             ? 'No leave requests found.'
//                             : `No ${filter.toLowerCase()} requests found.`
//                         }
//                       </td>
//                     </tr>
//                   )}
//                   {paginatedRequests.map((r, i) => {
//                     const formNo = getFormNo(r);
//                     const sno = getServiceNo(r);
//                     const status = getStatus(r).toUpperCase();
//                     const isPendingReq = status === 'PENDING';

//                     return (
//                       <tr
//                         key={formNo || i}
//                         className={`${i % 2 === 1 ? 'bg-surface-50/40' : ''} hover:bg-primary-50/30 transition-colors`}
//                       >
//                         <td className="px-5 py-3 font-medium text-gray-900">{formNo}</td>
//                         <td className="px-5 py-3 text-gray-700">{employeeMap[sno] || sno || '—'}</td>
//                         <td className="px-5 py-3 text-gray-700">
//                           {leaveTypeMap[getTypeId(r)] || `Type #${getTypeId(r) || '—'}`}
//                         </td>
//                         <td className="px-5 py-3 text-gray-700">{fmtDate(getFromDate(r))}</td>
//                         <td className="px-5 py-3 text-gray-700">{fmtDate(getToDate(r))}</td>
//                         <td className="px-5 py-3 font-semibold text-gray-800">{getTotalDays(r) || '—'}</td>
//                         <td className="px-5 py-3">
//                           <StatusBadge status={status} />
//                         </td>
//                         <td className="px-5 py-3">
//                           <button
//                             onClick={() => openModal(r)}
//                             className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${isPendingReq
//                               ? 'bg-primary-50 text-primary-700 hover:bg-primary-100'
//                               : 'bg-gray-50 text-gray-500 hover:bg-gray-100'
//                               }`}
//                           >
//                             <Eye size={13} />
//                             {isPendingReq ? 'Review' : 'View'}
//                           </button>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination */}
//             {filteredRequests.length > 0 && (
//               <Pagination
//                 currentPage={currentPage}
//                 totalPages={Math.ceil(filteredRequests.length / ROWS_PER_PAGE)}
//                 onPageChange={setCurrentPage}
//                 itemsCount={paginatedRequests.length}
//                 totalItems={filteredRequests.length}
//               />
//             )}
//           </>
//         )}
//       </div>

//       {/* ── Modal ────────────────────────────────────────────── */}
//       {modalOpen && selectedRequest && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
//           <div className="w-full max-w-2xl max-h-[90vh] overflow-y-auto rounded-xl bg-white shadow-lg">
//             {/* Modal Header */}
//             <div className="sticky top-0 bg-white z-10 border-b border-gray-100 px-6 py-4">
//               <div className="flex items-start justify-between">
//                 <div>
//                   <h2 className="text-base font-semibold text-gray-900">
//                     Leave Request #{getFormNo(selectedRequest)}
//                     {(() => {
//                       const serviceNo = getServiceNo(selectedRequest);
//                       const employeeName = employeeMap[serviceNo] || '';
//                       return employeeName ? ` - ${employeeName}` : '';
//                     })()}
//                   </h2>
//                 </div>
//                 <div className="flex items-center gap-3">
//                   <StatusBadge status={getStatus(selectedRequest)} />
//                   <button
//                     onClick={closeModal}
//                     className="text-gray-400 hover:text-gray-600 transition-colors"
//                     aria-label="Close"
//                   >
//                     <X size={20} />
//                   </button>
//                 </div>
//               </div>
//             </div>

//             {/* Request Details */}
//             <div className="p-6">
//               <div className="grid grid-cols-2 gap-4">
//                 <DetailField label="Form No">
//                   {getFormNo(selectedRequest) || '—'}
//                 </DetailField>
//                 <DetailField label="Service No">
//                   {getServiceNo(selectedRequest) || '—'}
//                 </DetailField>
//                 <DetailField label="Leave Type">
//                   {leaveTypeMap[getTypeId(selectedRequest)] || `Type #${getTypeId(selectedRequest) || '—'}`}
//                 </DetailField>
//                 <DetailField label="Total Days">
//                   <span className="font-semibold">{getTotalDays(selectedRequest) || '—'} day(s)</span>
//                 </DetailField>
//                 <DetailField label="From Date">
//                   {fmtDate(getFromDate(selectedRequest))}
//                 </DetailField>
//                 <DetailField label="To Date">
//                   {fmtDate(getToDate(selectedRequest))}
//                 </DetailField>
//                 <DetailField label="Contact No">
//                   {getContactNo(selectedRequest) || '—'}
//                 </DetailField>
//                 <DetailField label="Status">
//                   <StatusBadge status={getStatus(selectedRequest)} />
//                 </DetailField>
//               </div>

//               {/* Reason */}
//               <div className="mt-4 border-t border-gray-100 pt-4">
//                 <DetailField label="Reason">
//                   <div className="rounded-lg border border-gray-200 bg-gray-50 px-3 py-2.5 text-sm text-gray-800">
//                     {getReason(selectedRequest) || 'No reason provided'}
//                   </div>
//                 </DetailField>
//               </div>

//               {/* Attachment */}
//               {getAttachmentPath(selectedRequest) && (
//                 <div className="mt-4">
//                   <DetailField label="Attachment">
//                     <button
//                       type="button"
//                       onClick={() => openAttachment(getAttachmentPath(selectedRequest))}
//                       className="text-primary-600 hover:text-primary-700 text-sm underline cursor-pointer"
//                     >
//                       View Attachment
//                     </button>
//                   </DetailField>
//                 </div>
//               )}

//               {/* Error in modal */}
//               {error && (
//                 <div className="mt-4 flex items-center gap-2 px-4 py-3 bg-red-50 border border-red-200 rounded-xl text-red-700 text-sm">
//                   <AlertCircle size={14} />{error}
//                 </div>
//               )}

//               {/* Action buttons - Only for PENDING requests */}
//               {isPendingLeave(selectedRequest) && (
//                 <div className="mt-6 border-t border-gray-100 pt-4">
//                   <DetailField label="Remarks (Optional)">
//                     <input
//                       type="text"
//                       value={remarks}
//                       onChange={(e) => setRemarks(e.target.value)}
//                       placeholder="Add a note for this decision..."
//                       className="w-full rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-800 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
//                     />
//                   </DetailField>

//                   <div className="mt-4 flex gap-3 justify-end">
//                     <button
//                       onClick={closeModal}
//                       className="rounded-lg border border-gray-200 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
//                     >
//                       Cancel
//                     </button>
//                     <button
//                       onClick={() => decide('REJECTED')}
//                       disabled={deciding || !currentUserId}
//                       className="flex items-center gap-2 rounded-lg bg-red-600 px-6 py-2.5 text-sm font-medium text-white hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-50 transition-colors"
//                     >
//                       {deciding ? <Loader2 size={15} className="animate-spin" /> : <X size={15} />}
//                       Reject
//                     </button>
//                     <button
//                       onClick={() => decide('APPROVED')}
//                       disabled={deciding || !currentUserId}
//                       className="flex items-center gap-2 rounded-lg bg-primary-600 px-6 py-2.5 text-sm font-medium text-white hover:bg-primary-700 disabled:cursor-not-allowed disabled:opacity-50 transition-colors"
//                     >
//                       {deciding ? <Loader2 size={15} className="animate-spin" /> : <Check size={15} />}
//                       Approve
//                     </button>
//                   </div>
//                 </div>
//               )}

//               {/* Show message for non-pending requests */}
//               {!isPendingLeave(selectedRequest) && (
//                 <div className="mt-6 border-t border-gray-100 pt-4 flex justify-end">
//                   <button
//                     onClick={closeModal}
//                     className="rounded-lg border border-gray-200 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
//                   >
//                     Close
//                   </button>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }



import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Check, X, RefreshCw, AlertCircle, Loader2, Eye,
  ChevronLeft, ChevronRight,
} from 'lucide-react';

import EmployeeSearch from '../../components/common/EmployeeSearch';
import {
  fetchLeaveRequestsByStatus,
  approveLeave,
  rejectLeave,
} from '../../store/slices/leaveSlice';
import {
  PENDING_LEAVE_STATUS,
  APPROVED_LEAVE_STATUS,
  REJECT_LEAVE_STATUS,
  CANCEL_LEAVE_STATUS,
} from '../../constants/leaveConstent';

import LeaveService from '../../services/LeaveService';
import toIsoDate from '../../utils/dateFormat';
import Table, { TABLE_THEME } from '../../components/Table/Table';

const LABEL = TABLE_THEME.fieldLabel;

// ─── Status Meta ──────────────────────────────────────────────────────────
const STATUS_META = {
  PENDING: 'bg-amber-50 text-amber-700',
  APPROVED: 'bg-emerald-50 text-emerald-700',
  REJECTED: 'bg-red-50 text-red-700',
  CANCELLED: 'bg-gray-100 text-gray-500',
  CANCELED: 'bg-gray-100 text-gray-500',
};

const statusClass = (s) => STATUS_META[(s || '').toUpperCase()] || 'bg-gray-100 text-gray-500';
const statusLabel = (s) => {
  const up = (s || '').toUpperCase();
  if (up === 'CANCELED') return 'Cancelled';
  return up ? up.charAt(0) + up.slice(1).toLowerCase() : '—';
};

const STATUS_TABS = [
  { id: 'ALL', label: 'All' },
  { id: 'PENDING', label: 'Pending' },
  { id: 'APPROVED', label: 'Approved' },
  { id: 'REJECTED', label: 'Rejected' },
];

// ─── Safe field getters ───────────────────────────────────────────────────
const g = (leave, key) => {
  const v = leave?.[key];
  return (!v || v === 'null') ? '' : String(v).trim();
};

const getFormId = (l) => g(l, 'HLF_FORM_ID');
const getFormNo = (l) => g(l, 'HLF_FORM_NO');
const getServiceNo = (l) => g(l, 'HLF_EMP_SERVICE_NO');
const getTypeId = (l) => g(l, 'HLF_LEAVE_TYPE_ID');
const getFromDate = (l) => g(l, 'HLF_FROM_DATE');
const getToDate = (l) => g(l, 'HLF_TO_DATE');
const getTotalDays = (l) => g(l, 'HLF_TOTAL_DAYS');
const getReason = (l) => g(l, 'HLF_REASON');
const getStatus = (l) => g(l, 'HLF_STATUS');
const getAppliedDate = (l) => g(l, 'HLF_APPLIED_DATE');
const getContactNo = (l) => g(l, 'HLF_CONTACT_NO') || g(l, 'p_hlf_contact_no') || '';
const getAttachmentPath = (l) => g(l, 'HLF_ATTACHMENT_PATH') || '';
const isPendingLeave = (l) => getStatus(l).toUpperCase() === 'PENDING';

const fmtDate = (v) => toIsoDate(v) || '—';

const ROWS_PER_PAGE = 7;

// ─── Status Badge ─────────────────────────────────────────────────────────
function StatusBadge({ status }) {
  return (
    <span className={`inline-block rounded-full px-3 py-1 text-xs font-medium ${statusClass(status)}`}>
      {statusLabel(status)}
    </span>
  );
}

// ─── Detail Field ─────────────────────────────────────────────────────────
function DetailField({ label, children }) {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">{label}</span>
      <div className="text-sm text-gray-800">{children || '—'}</div>
    </div>
  );
}

// ─── Main Component ───────────────────────────────────────────────────────
export default function LeaveApproval() {
  const dispatch = useDispatch();
  const { employees, loading: employeesLoading } = useSelector(s => s.employees || {});

  // ── Current user id ──────────────────────────────────────────────────────
  const currentUserId = useSelector(s => {
    const fromAuth = s.auth?.user?.userId ||
      s.auth?.user?.UserId ||
      s.auth?.userId ||
      s.auth?.UserId ||
      s.auth?.user?.id ||
      '';

    if (fromAuth) return fromAuth;

    try {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        const user = JSON.parse(storedUser);
        const id = user?.id || user?.userId || user?.UserId || user?.serviceNo || '';
        if (id) return id;
      }
    } catch (e) { }

    return localStorage.getItem('userId') ||
      localStorage.getItem('UserId') ||
      localStorage.getItem('serviceNo') ||
      'SYSTEMSEMS';
  });

  const [leaves, setLeaves] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [statusTab, setStatusTab] = useState('PENDING');
  const [selectedEmployee, setSelectedEmployee] = useState({
    employeeId: '__ALL__',
    name: 'All Employees',
    isAll: true,
  });
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [remarks, setRemarks] = useState('');
  const [deciding, setDeciding] = useState(false);
  const [leaveTypeMap, setLeaveTypeMap] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  // Reset page when tab or employee changes
  useEffect(() => {
    setCurrentPage(1);
  }, [statusTab, selectedEmployee?.serviceNo, selectedEmployee?.isAll]);

  // ── Fetch leave types ───────────────────────────────────────────────────
  useEffect(() => {
    let cancelled = false;
    LeaveService.GetLeaveTypeList()
      .then(res => {
        const rows = res?.data?.ResultSet || res?.ResultSet || [];
        const map = {};
        rows.forEach(r => {
          const id = r.HLT_TYPE_ID ?? r.TYPE_ID ?? r.TypeId;
          const name = r.HLT_NAME ?? r.TYPE_NAME ?? r.TypeName;
          if (id != null) map[String(id)] = name;
        });
        if (!cancelled) setLeaveTypeMap(map);
      })
      .catch(() => { });
    return () => { cancelled = true; };
  }, []);

  // ── Employee map ────────────────────────────────────────────────────────
  const employeeMap = useMemo(() => {
    const map = {};
    if (!Array.isArray(employees) || employees.length === 0) return map;

    employees.forEach(e => {
      const sno = e.p_ced_service_no ||
        e.HED_SERVICE_NO ||
        e.HED_CED_SERVICE_NO ||
        e.serviceNo ||
        e.HED_EMPLOYEE_ID ||
        e.employeeId ||
        '';
      if (!sno) return;

      const name = e.p_report_name ||
        e.HED_REPORT_NAME ||
        e.reportName ||
        `${e.p_first_name || e.HED_FIRST_NAME || e.firstName || ''} ${e.p_last_name || e.HED_LAST_NAME || e.lastName || ''}`.trim() ||
        e.name ||
        '';

      map[String(sno)] = name || String(sno);
    });
    return map;
  }, [employees]);

  // ── Employee options for EmployeeSearch ─────────────────────────────────
  const employeeOptions = useMemo(() => {
    if (!Array.isArray(employees)) return [];

    return employees
      .map((emp) => {
        const serviceNo =
          emp.p_ced_service_no ||
          emp.HED_SERVICE_NO ||
          emp.HED_CED_SERVICE_NO ||
          emp.serviceNo ||
          '';

        const name =
          emp.p_report_name ||
          emp.HED_REPORT_NAME ||
          emp.reportName ||
          `${emp.p_first_name || emp.HED_FIRST_NAME || emp.firstName || ''} ${emp.p_last_name || emp.HED_LAST_NAME || emp.lastName || ''}`.trim() ||
          'Unnamed Employee';

        return {
          employeeId: String(serviceNo || emp.HED_EMPLOYEE_ID || emp.employeeId || ''),
          serviceNo: String(serviceNo),
          name,
          department: emp.p_department_name || emp.HDD_DEPARTMENT_NAME || '',
        };
      })
      .filter((e) => e.employeeId);
  }, [employees]);

  // ── Fetch all requests ──────────────────────────────────────────────────
  const fetchAllRequests = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const [pendingResult, approvedResult, rejectedResult] = await Promise.all([
        dispatch(fetchLeaveRequestsByStatus(PENDING_LEAVE_STATUS)).unwrap(),
        dispatch(fetchLeaveRequestsByStatus(APPROVED_LEAVE_STATUS)).unwrap(),
        dispatch(fetchLeaveRequestsByStatus(REJECT_LEAVE_STATUS)).unwrap(),
        dispatch(fetchLeaveRequestsByStatus(CANCEL_LEAVE_STATUS)).unwrap(),
      ]);

      const pending = Array.isArray(pendingResult) ? pendingResult : (pendingResult?.payload || pendingResult?.data || []);
      const approved = Array.isArray(approvedResult) ? approvedResult : (approvedResult?.payload || approvedResult?.data || []);
      const rejected = Array.isArray(rejectedResult) ? rejectedResult : (rejectedResult?.payload || rejectedResult?.data || []);

      const allLeaves = [
        ...(Array.isArray(pending) ? pending : []),
        ...(Array.isArray(approved) ? approved : []),
        ...(Array.isArray(rejected) ? rejected : []),
      ].sort((a, b) =>
        new Date(getAppliedDate(b) || getFromDate(b)) - new Date(getAppliedDate(a) || getFromDate(a))
      );

      setLeaves(allLeaves);
      setCurrentPage(1);
    } catch (e) {
      console.error('[LeaveApproval] Error fetching leaves:', e);
      setError(typeof e === 'string' ? e : (e?.message || 'Failed to load leave requests'));
      setLeaves([]);
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  useEffect(() => { fetchAllRequests(); }, [fetchAllRequests]);

  // ── Filtered rows ───────────────────────────────────────────────────────
  const filtered = useMemo(() => {
    let result = leaves;

    if (statusTab !== 'ALL') {
      result = result.filter(r => getStatus(r).toUpperCase() === statusTab);
    }

    if (selectedEmployee && !selectedEmployee.isAll) {
      result = result.filter(r => getServiceNo(r) === selectedEmployee.serviceNo);
    }

    return result;
  }, [leaves, statusTab, selectedEmployee]);

  // ── Pagination ──────────────────────────────────────────────────────────
  const totalPages = Math.ceil(filtered.length / ROWS_PER_PAGE);
  const startIndex = (currentPage - 1) * ROWS_PER_PAGE;
  const endIndex = startIndex + ROWS_PER_PAGE;
  const currentItems = filtered.slice(startIndex, endIndex);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  // ── Modal handlers ──────────────────────────────────────────────────────
  const openModal = (request) => {
    setSelectedRequest(request);
    setRemarks('');
    setError('');
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedRequest(null);
    setRemarks('');
    setError('');
  };

  // ── Approve / Reject ────────────────────────────────────────────────────
  async function decide(status) {
    if (!selectedRequest || deciding) return;

    if (!currentUserId || currentUserId.trim() === '') {
      setError('User ID is missing. Please log in again.');
      return;
    }

    const currentStatus = getStatus(selectedRequest).toUpperCase();
    if (currentStatus !== 'PENDING') {
      setError('This request has already been processed.');
      return;
    }

    setDeciding(true);
    setError('');
    try {
      const decision = {
        LeaveFormId: getFormId(selectedRequest),
        FormNo: getFormNo(selectedRequest),
        UserId: currentUserId,
        Reason: remarks,
      };

      if (status === 'APPROVED') {
        await dispatch(approveLeave(decision)).unwrap();
      } else {
        await dispatch(rejectLeave(decision)).unwrap();
      }

      await fetchAllRequests();
      closeModal();
    } catch (e) {
      console.error('[LeaveApproval] Decision error:', e);
      setError(typeof e === 'string' ? e : (e?.message || 'Failed to submit decision'));
    } finally {
      setDeciding(false);
    }
  }

  // ── Attachment ──────────────────────────────────────────────────────────
  const openAttachment = (dataUrl) => {
    try {
      const [header, base64Data] = dataUrl.split(',');
      const mimeMatch = header.match(/data:(.*?);base64/);
      const mimeType = mimeMatch ? mimeMatch[1] : 'application/octet-stream';

      const byteString = atob(base64Data);
      const byteArray = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) byteArray[i] = byteString.charCodeAt(i);

      const blob = new Blob([byteArray], { type: mimeType });
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, '_blank', 'noopener,noreferrer');
      setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
    } catch (err) {
      console.error('[LeaveApproval] Failed to open attachment:', err);
    }
  };

  const handleEmployeeSelect = (employee) => {
    if (!employee) {
      setSelectedEmployee({ employeeId: '__ALL__', name: 'All Employees', isAll: true });
    } else {
      setSelectedEmployee(employee);
    }
  };

  // ── Table Columns ───────────────────────────────────────────────────────
  const columns = [
    {
      key: 'formNo',
      label: 'Form',
      className: 'text-gray-500 font-medium',
      render: (r) => getFormNo(r),
    },
    {
      key: 'serviceNo',
      label: 'Service No',
      className: 'text-gray-900',
      render: (r) => <p className="text-xs text-gray-400">{getServiceNo(r)}</p>,
    },
    {
      key: 'employee',
      label: 'Employee',
      className: 'text-gray-900',
      render: (r) => {
        const sno = getServiceNo(r);
        const name = employeeMap[sno];
        return <p className="font-medium text-gray-900">{name || sno || '—'}</p>;
      },
    },
    {
      key: 'leaveType',
      label: 'Leave Type',
      className: 'text-gray-600',
      render: (r) => leaveTypeMap[getTypeId(r)] || `Type #${getTypeId(r) || '—'}`,
    },
    {
      key: 'fromDate',
      label: 'From',
      className: 'text-gray-600',
      render: (r) => fmtDate(getFromDate(r)),
    },
    {
      key: 'toDate',
      label: 'To',
      className: 'text-gray-600',
      render: (r) => fmtDate(getToDate(r)),
    },
    {
      key: 'days',
      label: 'Days',
      className: 'text-gray-800 font-semibold',
      render: (r) => getTotalDays(r) || '—',
    },
    {
      key: 'status',
      label: 'Status',
      className: 'text-gray-600',
      render: (r) => <StatusBadge status={getStatus(r)} />,
    },
    {
      key: 'actions',
      label: 'Actions',
      className: 'text-gray-600',
      render: (r) => {
        const isPendingReq = getStatus(r).toUpperCase() === 'PENDING';
        return (
          <button
            onClick={() => openModal(r)}
            className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${isPendingReq
              ? 'bg-primary-50 text-primary-700 hover:bg-primary-100'
              : 'bg-gray-50 text-gray-500 hover:bg-gray-100'
              }`}
          >
            <Eye size={13} />
            {isPendingReq ? 'Review' : 'View'}
          </button>
        );
      },
    },
  ];

  return (
    <div className="p-6 space-y-4">

      {/* ── Filters (Search + Status + Refresh) ──────────────────── */}
      <div className="flex flex-wrap items-end gap-4">
        <div className="flex-1 min-w-[240px] max-w-[400px]">
          <span className={LABEL}>Search Employee</span>
          <EmployeeSearch
            value={selectedEmployee}
            onSelect={handleEmployeeSelect}
            employees={employeeOptions}
            loading={employeesLoading}
            showAllOption
          />
        </div>

        <div>
          <span className={LABEL}>Status</span>
          <div className="flex gap-1 flex-wrap">
            {STATUS_TABS.map(t => (
              <button
                key={t.id}
                onClick={() => setStatusTab(t.id)}
                className={`px-3 py-1.5 rounded-lg text-xs font-semibold transition-colors
                ${statusTab === t.id
                    ? 'bg-primary-600 text-white'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                  }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        {/* Refresh — same row, pushed to the right */}
        <button
          onClick={fetchAllRequests}
          disabled={loading}
          className="ml-auto flex shrink-0 items-center gap-2 rounded-lg bg-primary-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-primary-700 transition-colors disabled:opacity-50"
        >
          <RefreshCw size={16} className={loading ? 'animate-spin' : ''} />
          Refresh
        </button>
      </div>

      {/* ── Error (hidden when modal is open) ────────────────────── */}
      {error && !modalOpen && (
        <div className="flex items-center gap-2 px-4 py-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
          <AlertCircle size={16} />
          {error}
        </div>
      )}

      {/* ── Table ─────────────────────────────────────────────────── */}
      <Table
        columns={columns}
        rows={currentItems}
        rowKey={(r) => `${getFormNo(r)}-${getServiceNo(r)}`}
        loading={loading}
        loadingMessage="Loading leave requests..."
        emptyMessage={
          selectedEmployee && !selectedEmployee.isAll
            ? `No ${statusTab !== 'ALL' ? statusTab.toLowerCase() + ' ' : ''}leave requests found for ${selectedEmployee.name}`
            : statusTab === 'ALL'
              ? 'No leave requests available.'
              : `No ${statusTab.toLowerCase()} requests found.`
        }
        minWidth={1000}
        scrollClassName=""
        emptyValue="-"
        defaultSort={{ key: 'fromDate', dir: 'desc' }}
      />

      {/* ── Pagination ────────────────────────────────────────────── */}
      {!loading && !error && filtered.length > 0 && (
        <div className="flex items-center justify-between border-t border-gray-200 px-5 py-4">
          <div className="text-sm text-gray-500">
            Showing {startIndex + 1} to {Math.min(endIndex, filtered.length)} of {filtered.length} entries
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="flex h-8 w-8 items-center justify-center rounded-md border border-gray-200 text-gray-500 hover:bg-surface-50 disabled:cursor-not-allowed disabled:opacity-50"
              aria-label="Previous page"
            >
              <ChevronLeft size={16} />
            </button>

            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
              let pageNum;
              if (totalPages <= 5) {
                pageNum = i + 1;
              } else if (currentPage <= 3) {
                pageNum = i + 1;
              } else if (currentPage >= totalPages - 2) {
                pageNum = totalPages - 4 + i;
              } else {
                pageNum = currentPage - 2 + i;
              }

              return (
                <button
                  key={pageNum}
                  onClick={() => handlePageChange(pageNum)}
                  className={`h-8 min-w-8 rounded-md px-2 text-sm font-medium ${currentPage === pageNum
                    ? 'bg-primary-600 text-white'
                    : 'text-gray-700 hover:bg-surface-50'
                    }`}
                >
                  {pageNum}
                </button>
              );
            })}

            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="flex h-8 w-8 items-center justify-center rounded-md border border-gray-200 text-gray-500 hover:bg-surface-50 disabled:cursor-not-allowed disabled:opacity-50"
              aria-label="Next page"
            >
              <ChevronRight size={16} />
            </button>
          </div>
        </div>
      )}

      {/* ── Modal (unchanged) ─────────────────────────────────────── */}
      {modalOpen && selectedRequest && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
          <div className="w-full max-w-2xl max-h-[90vh] overflow-y-auto rounded-xl bg-white shadow-lg">
            {/* Modal Header */}
            <div className="sticky top-0 bg-white z-10 border-b border-gray-100 px-6 py-4">
              <div className="flex items-start justify-between">
                <div>
                  <h2 className="text-base font-semibold text-gray-900">
                    Leave Request #{getFormNo(selectedRequest)}
                    {(() => {
                      const serviceNo = getServiceNo(selectedRequest);
                      const employeeName = employeeMap[serviceNo] || '';
                      return employeeName ? ` - ${employeeName}` : '';
                    })()}
                  </h2>
                </div>
                <div className="flex items-center gap-3">
                  <StatusBadge status={getStatus(selectedRequest)} />
                  <button
                    onClick={closeModal}
                    className="text-gray-400 hover:text-gray-600 transition-colors"
                    aria-label="Close"
                  >
                    <X size={20} />
                  </button>
                </div>
              </div>
            </div>

            {/* Request Details */}
            <div className="p-6">
              <div className="grid grid-cols-2 gap-4">
                <DetailField label="Form No">{getFormNo(selectedRequest) || '—'}</DetailField>
                <DetailField label="Service No">{getServiceNo(selectedRequest) || '—'}</DetailField>
                <DetailField label="Leave Type">
                  {leaveTypeMap[getTypeId(selectedRequest)] || `Type #${getTypeId(selectedRequest) || '—'}`}
                </DetailField>
                <DetailField label="Total Days">
                  <span className="font-semibold">{getTotalDays(selectedRequest) || '—'} day(s)</span>
                </DetailField>
                <DetailField label="From Date">{fmtDate(getFromDate(selectedRequest))}</DetailField>
                <DetailField label="To Date">{fmtDate(getToDate(selectedRequest))}</DetailField>
                <DetailField label="Contact No">{getContactNo(selectedRequest) || '—'}</DetailField>
                <DetailField label="Status"><StatusBadge status={getStatus(selectedRequest)} /></DetailField>
              </div>

              {/* Reason */}
              <div className="mt-4 border-t border-gray-100 pt-4">
                <DetailField label="Reason">
                  <div className="rounded-lg border border-gray-200 bg-gray-50 px-3 py-2.5 text-sm text-gray-800">
                    {getReason(selectedRequest) || 'No reason provided'}
                  </div>
                </DetailField>
              </div>

              {/* Attachment */}
              {getAttachmentPath(selectedRequest) && (
                <div className="mt-4">
                  <DetailField label="Attachment">
                    <button
                      type="button"
                      onClick={() => openAttachment(getAttachmentPath(selectedRequest))}
                      className="text-primary-600 hover:text-primary-700 text-sm underline cursor-pointer"
                    >
                      View Attachment
                    </button>
                  </DetailField>
                </div>
              )}

              {/* Error in modal */}
              {error && (
                <div className="mt-4 flex items-center gap-2 px-4 py-3 bg-red-50 border border-red-200 rounded-xl text-red-700 text-sm">
                  <AlertCircle size={14} />{error}
                </div>
              )}

              {/* Action buttons - only for PENDING */}
              {isPendingLeave(selectedRequest) && (
                <div className="mt-6 border-t border-gray-100 pt-4">
                  <DetailField label="Remarks (Optional)">
                    <input
                      type="text"
                      value={remarks}
                      onChange={(e) => setRemarks(e.target.value)}
                      placeholder="Add a note for this decision..."
                      className="w-full rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-800 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
                    />
                  </DetailField>

                  <div className="mt-4 flex gap-3 justify-end">
                    <button
                      onClick={closeModal}
                      className="rounded-lg border border-gray-200 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={() => decide('REJECTED')}
                      disabled={deciding || !currentUserId}
                      className="flex items-center gap-2 rounded-lg bg-red-600 px-6 py-2.5 text-sm font-medium text-white hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-50 transition-colors"
                    >
                      {deciding ? <Loader2 size={15} className="animate-spin" /> : <X size={15} />}
                      Reject
                    </button>
                    <button
                      onClick={() => decide('APPROVED')}
                      disabled={deciding || !currentUserId}
                      className="flex items-center gap-2 rounded-lg bg-primary-600 px-6 py-2.5 text-sm font-medium text-white hover:bg-primary-700 disabled:cursor-not-allowed disabled:opacity-50 transition-colors"
                    >
                      {deciding ? <Loader2 size={15} className="animate-spin" /> : <Check size={15} />}
                      Approve
                    </button>
                  </div>
                </div>
              )}

              {/* Close for non-pending */}
              {!isPendingLeave(selectedRequest) && (
                <div className="mt-6 border-t border-gray-100 pt-4 flex justify-end">
                  <button
                    onClick={closeModal}
                    className="rounded-lg border border-gray-200 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
                  >
                    Close
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}